import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <main className="container-x flex min-h-[70vh] flex-col items-start justify-center pt-32" data-testid="not-found-page">
      <SEOHead title={t.meta.notFound.title} description={t.meta.notFound.description} />
      <p className="font-display text-[8rem] leading-none text-sand-200">404</p>
      <h1 className="h2 mt-4">{t.common.pageNotFound}</h1>
      <Link to="/" className="btn-primary mt-8" data-testid="not-found-home-link">{t.common.backHome}</Link>
    </main>
  );
}
